import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { filter, map, shareReplay, skip, take, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  isMobile$: Observable<boolean>;
  isDesktop$: Observable<boolean>;
  private _isMobile = new BehaviorSubject<boolean>(false);
  private _isDesktop = new BehaviorSubject<boolean>(true);

  get isMobile(): boolean {
    return this._isMobile.value;
  }

  get isDesktop(): boolean {
    return this._isDesktop.value;
  }

  constructor(private breakpointObserver: BreakpointObserver) {
    this.isMobile$ = this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .pipe(
        map((result) => result.matches),
        tap((matches) => {
          this._isMobile.next(matches);
          this._isDesktop.next(!matches);
        }),
        shareReplay(1),
      );
    this.isDesktop$ = this.isMobile$
      .pipe(
        map((isMobile) => !isMobile),
        shareReplay(1),
      );
  }
}
